import { QueryKey, RevisedWorkflow } from 'api/model.ts';
import { getWorkflowsBatch } from 'api/workflows/requests.ts';
import { useQuery } from '@tanstack/react-query';

type Options = {
  revisedWorkflows?: RevisedWorkflow[];
};

const useRevisedWorkflows = ({ revisedWorkflows }: Options) => {
  const revisedWorkflowsKey = revisedWorkflows?.map((wf) => `${wf.workflow_id}-${wf.revision}`).join('|');

  const {
    data: revisedWorkflowsData,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: [QueryKey.RevisedWorkflows, revisedWorkflowsKey],
    queryFn: () => {
      if (!revisedWorkflows?.length) return [];
      return getWorkflowsBatch(revisedWorkflows);
    },
    enabled: !!revisedWorkflows?.length,
  });

  return {
    revisedWorkflowsData,
    isLoading,
    isFetching,
  };
};

export default useRevisedWorkflows;
